export default "__VITE_ASSET__DW5Q2cGk__"